import { useQuery, QueryResult } from '@apollo/client';
import { useRouter } from 'next/router';
// Hocks
import { useRedirectOnError } from 'hooks';
// Api
import { GET_MEDIA_POST } from 'api/mediaPost/queries';
// Types
import {
  GetMediaPost,
  GetMediaPostVariables,
} from 'api/mediaPost/types/GetMediaPost';

export const useGetMediaPost = (): QueryResult<
  GetMediaPost,
  GetMediaPostVariables
> => {
  const router = useRouter();
  const { mediaPostSlug, athleteSlug } = router.query;
  const cleanMediaPostSlug = (mediaPostSlug as string)?.split('?')[0];

  const data = useQuery<GetMediaPost, GetMediaPostVariables>(GET_MEDIA_POST, {
    variables: {
      input: {
        slug: cleanMediaPostSlug,
        storeSlug: athleteSlug as string,
      },
    },
    skip: !cleanMediaPostSlug,
    // Hydration: the post is already fetched + cached by `getInitialProps` on
    // the server, so `cache-first` avoids the duplicate POST that fired on
    // first client render. Subsequent re-mounts (SPA revisit, refocus, etc.)
    // flip to `cache-and-network` so edits made server-side (title, body,
    // view-count, etc.) propagate in the background instead of being pinned
    // to the stale SSR snapshot for the whole session.
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-and-network',
  });

  useRedirectOnError({
    error: data.error,
    redirectTo: `/${athleteSlug}/media`,
  });

  return data;
};
